import React from 'react';
import { TableRow, TableCell, CircularProgress } from '@mui/material';

const LoadingState = ({ colSpan }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        <CircularProgress size={24} />
      </TableCell>
    </TableRow>
  );
};

export default LoadingState; 